// src/config.js

// Para usar estas variables en desarrollo local
/*
REACT_APP_API_URL=http://localhost:5267/api
REACT_APP_FRONTEND_URL=http://localhost:3000
*/

// Configuración centralizada
// Prioridad: 1. Configuración externa (window.APP_CONFIG), 2. Variables de entorno, 3. Valor por defecto
export const API_BASE_URL = (window.APP_CONFIG && window.APP_CONFIG.API_URL) ||
  process.env.REACT_APP_API_URL ||
  '/api'; // Relative for All-in-One deployment

export const FRONTEND_URL = (window.APP_CONFIG && window.APP_CONFIG.FRONTEND_URL) ||
  process.env.REACT_APP_FRONTEND_URL ||
  'http://localhost:3000';

// api_vicsa: identidad central (login SSO con Microsoft). Es un dominio
// distinto al de esta app -- no se puede derivar de API_BASE_URL.
export const SSO_BASE_URL = (window.APP_CONFIG && window.APP_CONFIG.SSO_URL) ||
  process.env.REACT_APP_SSO_URL ||
  'https://api.bunzlsa.com';

// Dominios corporativos que van directo a Microsoft en el login (deben
// coincidir con DOMINIOS_PERMITIDOS en el .env de api_vicsa -- esto es solo
// para decidir qué mostrar en la UI, la validación real siempre la hace el
// backend, no confiar en esta lista para nada de seguridad).
export const SSO_DOMINIOS = (window.APP_CONFIG && window.APP_CONFIG.SSO_DOMINIOS) ||
  ['vicsa.cl', 'b2bweb.cl', 'tecnoboga.cl', 'bunzlsa.com'];

// Login central para todas las apps del holding (SSO Microsoft o cuenta
// local en una sola pantalla). HelpDesk ya no muestra su propio formulario
// de login -- Login.jsx solo redirige para acá. Termina en el mismo
// mecanismo de "constancia firmada" que ya canjea /sso-callback, sin
// cambios de ese lado.
export const LOGIN_CENTRAL_URL = (window.APP_CONFIG && window.APP_CONFIG.LOGIN_CENTRAL_URL) ||
  process.env.REACT_APP_LOGIN_CENTRAL_URL ||
  'https://login.bunzlsa.com';
export const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000;
export const SIGNALR_TIMEOUT = parseInt(process.env.REACT_APP_SIGNALR_TIMEOUT) || 10000;
export const DEBUG = process.env.REACT_APP_DEBUG === 'true';

export const config = {
  api: {
    baseURL: API_BASE_URL,
    timeout: API_TIMEOUT
  },
  frontend: {
    url: FRONTEND_URL
  },
  signalr: {
    timeout: SIGNALR_TIMEOUT
  },
  debug: DEBUG
};

// Función para actualizar la URL del API dinámicamente
export const updateApiUrl = (newUrl) => {
  // No modificar process.env en CRA (se sustituye en build y rompe el bundle)
  config.api.baseURL = newUrl;
};

// Función para obtener la URL base sin /api
export const getApiBaseUrl = () => {
  return config.api.baseURL.replace('/api', '');
};

// Los archivos en Storage/ no se sirven como estáticos (ServeStaticModule los excluye
// a propósito bajo /api/*) -- se sirven autenticados vía SecureFileModule
// (GET /securefile/preview/:subdirectory/:fileName). Las actas históricas viven siempre
// en Storage/actas/Historicas/<archivo>, así que se arma la URL a partir del nombre del
// archivo, con el subdirectorio anidado escapado como %2F para que Express lo entregue
// como un solo param en vez de partirlo en dos segmentos de ruta.
export const buildActaHistoricaUrl = (rutaArchivo) => {
  if (!rutaArchivo) return null;
  const fileName = rutaArchivo.split('/').pop();
  const baseUrl = config.api.baseURL.endsWith('/') ? config.api.baseURL.slice(0, -1) : config.api.baseURL;
  return `${baseUrl}/securefile/preview/actas%2FHistoricas/${encodeURIComponent(fileName)}`;
};